/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useRef, useState } from "react";
import "./section1.css";
import ContactForm from "../common/contactForm/contactForm";

export default function Section1({ onWorkClick }) {
  const [modal, showModal] = useState(false);
  const section1 = useRef(null);
  const onLoad = () => {
    section1.current.style.backgroundImage = 'url("/images/prof1.5.jpg")';
  };
  return (
    <section ref={section1} className="page-section section1 profile-pic-one">
      <img
        src="/images/prof1.5.jpg"
        className="d-none"
        onLoad={onLoad}
        alt="Mehthab Musambil"
      />
      <div className="container">
        <div className="row h-100 align-items-center ">
          <div className="col-lg-8 col-12">
            <h1
              className="display-4 font-weight-normal"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Hello, I’m
            </h1>
            <h1
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
              className="display-4 font-weight-bold"
            >
              Mehthab Musambil
            </h1>
            <h5
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="500"
              className="d-md-inline d-none font-weight-light"
            >
              Sr. Mobile App Developer at{" "}
              <a
                href="https://webook.com/en"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: 600 }}
                className="text-primary"
              >
                webook.com
              </a>
            </h5>
            <h5
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="500"
              className="d-inline d-md-none font-weight-light"
            >
              Sr. Mobile App Developer
              <br />
              <a
                href="https://webook.com/en"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: 600 }}
                className="text-primary"
              >
                at webook.com
              </a>
            </h5>
            <div
              className="mt-4 pt-2"
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="1000"
            >
              <button
                onClick={onWorkClick}
                type="button"
                className="btn btn-primary py-2 px-md-4"
              >
                <p className="mb-0 py-1 weight-700">EXPLORE PROJECTS</p>
              </button>
              <button
                type="button"
                className="btn btn-outline-primary py-2 px-md-4 ml-md-3 ml-2"
                onClick={() => showModal(true)}
              >
                <p className="mb-0 py-1 weight-700">
                  SAY HELLO{" "}
                  <span
                    role="image"
                    aria-label="say-hello"
                    aria-labelledby="hi"
                  >
                    👋
                  </span>
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <ContactForm modal={modal} showModal={(value) => showModal(value)} />
    </section>
  );
}
